module.exports = "/images/aiBotWhite.svg?4fe7aa2e2c295ecda3f8558cdd5afcd4";